import validator from 'validator';
import moment from 'moment';

export function passengerFormValidation(formData, options = {}) {
  if(formData){
    const validationErrors = {};
    const forEdit = options.forEdit === true;
    const requireUsernamePassword = options.requireUsernamePassword === true;
    
    if(!formData.first_name){
      validationErrors.first_name = "First name is required";
    } 
    if(!formData.last_name){
      validationErrors.last_name = "Last name is required";
    } 
    if(!formData.date_of_birth){
      validationErrors.date_of_birth = "Date of birth is required";
    } 
    if(!formData.gender){
      validationErrors.gender = "Please select gender.";
    } 
    if(!formData.pmi_number){
      validationErrors.pmi_number = "pmi number is required";
    }else if(!validator.isNumeric(formData.pmi_number)){
        validationErrors.pmi_number = "Please enter a number.";
    }
    if(!formData.payer || !String(formData.payer).trim()){
      validationErrors.payer = "Please select payer.";
    }
    // else if (formData.pmi_number.length !== 8) {
    //   validationErrors.pmi_number = "PMI number must be 8 digits";
    // }
    if(!formData.address_line_one){
      validationErrors.address_line_one = "Please enter address.";
    }
    if(!formData.state){
      validationErrors.state = "Please enter state.";
    }
    if(!formData.city){
      validationErrors.city = "Please enter city.";
    }
    if(!formData.zip){
      validationErrors.zip = "Please enter zip.";
    }
    // if(formData.home_phone!=='' && !formData.home_phone){
    //   validationErrors.home_phone = "Please enter phone.";
    // }

    if(!formData.cell_phone){
      validationErrors.cell_phone = "Please enter cell phone.";
    }
    if(!formData.pmi_number){
      validationErrors.pmi_number = "Please enter PMI number.";
    }
    if (!forEdit) {
      if (requireUsernamePassword) {
        if(!formData.email_address || !formData.email_address.trim()){
          validationErrors.email_address = "Email address is required.";
        } else if(!validator.isEmail(formData.email_address.trim())){
          validationErrors.email_address = "Please enter a valid email address.";
        }
        if(!formData.username || !formData.username.trim()){
          validationErrors.username = "Username is required.";
        }
        if(!formData.password || !formData.password.trim()){
          validationErrors.password = "Password is required.";
        }
      } else if (formData.email_address?.trim() && !validator.isEmail(formData.email_address.trim())) {
        validationErrors.email_address = "Please enter a valid email address.";
      }
    } else if (formData.email_address?.trim()) {
      if (!validator.isEmail(formData.email_address.trim())) {
        validationErrors.email_address = "Please enter a valid email address.";
      }
    }
    
    scrollToFirstError(validationErrors);
    return validationErrors;
  }
  }
export function driverFormValidation(formData,roleType) {
   // console.log(formData);
    if(formData){
      const validationErrors = {};
      
      if(!formData.first_name || !formData.first_name.trim()){
        validationErrors.first_name = "First name is required";
      } 
      if(!formData.last_name || !formData.last_name.trim()){
        validationErrors.last_name = "Last name is required";
      } 
      if(!formData.date_of_birth || !formData.date_of_birth.trim()){
        validationErrors.date_of_birth = "Date of birth is required";
      } 
      if(!formData.gender){
        validationErrors.gender = "Please select gender.";
      } 
      
      if(!formData.address_line_one || !formData.address_line_one.trim() ){
        validationErrors.address_line_one = "Please enter address.";
      }
      if(!formData.state){
        validationErrors.state = "Please enter state.";
      }
      if(!formData.city || !formData.city.trim()){
        validationErrors.city = "Please enter city.";
      }
      if(!formData.zip || !formData.zip.toString().trim()){
        validationErrors.zip = "Please enter zip.";
      }
      // if(!formData.cell_phone ){
      //   validationErrors.cell_phone = "Please enter phone.";
      // }
      // if(!formData.home_phone && roleType === 'driver'){
      //   validationErrors.home_phone = "Please enter phone.";
      // }
      // if((!formData.umpi_number || !formData.umpi_number.trim()) && roleType === 'driver'){
      //   validationErrors.umpi_number = "Please enter UMPI number .";
      // }
      if(formData.umpi_number && formData.umpi_number.length !== 10){

        validationErrors.umpi_number = "UMPI number must be 10 digits";
      }
      if(!formData.u_nme || !formData.u_nme.trim()){
        validationErrors.u_nme = "User Name is required.";
      }
      
      if(formData.is_edit !== '1'){
      if(!formData.u_pswd){
        validationErrors.u_pswd = "Passwords is required.";
      }
    }
    if(formData.u_pswd){
      if(!formData.c_pswd || formData.u_pswd.trim() !== formData.c_pswd.trim() ){
        validationErrors.c_pswd = "Passwords do not match.";
      }
    }
    scrollToFirstError(validationErrors);
      return validationErrors;
    }
}  
export function vehicleFormValidation(formData){
  //console.log("kk",formData);
  if(formData){
    const validationErrors = {};
    
    const vehicleName = (formData.vehicle_name || '').trim();
    const licensePlate = (formData.license_plate || '').trim();
    // Allow alphanumeric + spaces only (e.g. "AYI 390", "eyi390"). No special characters.
    const LICENSE_PLATE_REGEX = /^[A-Za-z0-9 ]+$/;

    if(!vehicleName){
      validationErrors.vehicle_name = "Vehicle name is required";
    }
    // if(!formData.vehicle_model){
    //   validationErrors.vehicle_model = "Vehicle model is required";
    // } 
    // if(!formData.model_year){
    //   validationErrors.model_year = "Vehicle model year is required";
    // } 
    // if(!formData.vehicle_number){
    //   validationErrors.vehicle_number = "Vehicle number is required.";
    // } 
    
    if(!licensePlate){
      validationErrors.license_plate = "License Plate is required.";
    } else if(!LICENSE_PLATE_REGEX.test(licensePlate)){
      validationErrors.license_plate = "License Plate allows only letters and numbers (spaces allowed). No special characters.";
    }
    // if(!formData.seating_capacity){
    //   validationErrors.seating_capacity = "Please enter seating capacity.";
    // }
    // if(!formData.wheel_capacity){
    //   validationErrors.wheel_capacity = "Please enter wheel capacity.";
    // }
    // if(!formData.is_certified){
    //   validationErrors.is_certified = "Please select MTM certified.";
    // } 
    if(formData.is_certified === "1"){
      if(!formData.start_date || formData.start_date === "Invalid date"){
        validationErrors.start_date = "Please enter start date.";
      }
      if(!formData.end_date || formData.end_date === "Invalid date"){
        validationErrors.end_date = "Please enter end date.";
      }
    }
    
    // if(!formData.is_insured){
    //   validationErrors.is_insured = "Please select vehicle Insured.";
    // } 
    if(formData.is_insured === '1'){
      if(!formData.insurance_start_date  || formData.insurance_start_date === "Invalid date"){
        validationErrors.insurance_start_date = "Please enter start date.";
      }
      if(!formData.insurance_end_date || formData.insurance_end_date === "Invalid date"){
        validationErrors.insurance_end_date = "Please enter end date.";
      }
    }
    scrollToFirstError(validationErrors);
    return validationErrors;
  }
}
export function scheduleFormValidation(formData, options = {}){
  if(formData){
    const validationErrors = {};
    const isMAPayer = options.isMAPayer === true;
    if (formData.date_mode === 'single') {
      if (!formData.schedule_date) {
        validationErrors.schedule_date = "Trip Date is required.";
      }
    } else if (formData.date_mode === 'range') {
      if (!formData.start_date) {
        validationErrors.start_date = "Start date is required.";
      } else if (!formData.end_date) {
        validationErrors.end_date = "End date is required.";
      } else if (new Date(formData.end_date) < new Date(formData.start_date)) {
        validationErrors.end_date = "End date cannot be before start date.";
      }
      
      // Add validation for frequency and selected days
      // console.log('Validating frequency and selectedDays:', {
      //   frequency: formData.frequency,
      //   selectedDays: formData.selectedDays,
      //   isWeeklyOrBiweekly: formData.frequency === 'weekly' || formData.frequency === 'biweekly',
      //   hasSelectedDays: formData.selectedDays && formData.selectedDays.length > 0
      // });
      
      if (!formData.frequency) {
        validationErrors.frequency = "Please select a frequency.";
      } else if ((formData.frequency === 'weekly' || formData.frequency === 'biweekly') && 
                 (!formData.selectedDays || formData.selectedDays.length === 0)) {
        validationErrors.selectedDays = "Please select at least one day for weekly/biweekly schedules.";
      }
    }
    if(formData.has_companions === 'Yes' && !formData.companion_count){
      validationErrors.companion_count = "Companion count is required";
    }
    // if(!formData.schedule_date){
    //   validationErrors.schedule_date = "Schedule date is required";
    // } 
    // if(!formData.location_type){
    //   validationErrors.location_type = "Location type is required";
    // }
    // else if(formData.location_type === '5' && !formData.other_location_type){
    //   validationErrors.other_location_type = "Please enter other location type.";
    // } 
    // if(formData.companion === true && !formData.companion_number){
    //   validationErrors.companion_number = "Companion is required";
    // } 

    // if(!formData.bill_amount){
    //   validationErrors.bill_amount = "Please enter bill amount.";
    // }
    
    if(!formData.number_of_leg){
      validationErrors.number_of_leg = "Please select leg.";
    }else if(formData.number_of_leg === '1' && !formData.leg_one_text){
      validationErrors.leg_one_text = "Please enter leg one text.";
    }
    if (isMAPayer) {
      if (!formData.ma_service_auth_id) {
        validationErrors.ma_service_auth_id = "Please select Service Type.";
      }
      // Scheduled miles are validated per leg in validateAccordion when validateScheduledMilesPerLeg is set.
    } else {
      if(!formData.transport_option){
        validationErrors.transport_option = "Please select Transport Options.";
      }
      if(!formData.appt_time){
        validationErrors.appt_time = "Please select appointment time.";
      }
    }
    // if(!formData.is_wait){
    //   validationErrors.is_wait = "Please select wait time.";
    // } 
    // Wait time (shown when is_wait === '1' in UpdatedSchedule.jsx)
    if(formData.is_wait == '1'){
      const hourRaw = (formData.hour ?? '').toString().trim();
      const minuteRaw = (formData.minute ?? '').toString().trim();
      const hour = hourRaw === '' ? NaN : Number(hourRaw);
      const minute = minuteRaw === '' ? NaN : Number(minuteRaw);

      if (isNaN(hour) && isNaN(minute)) {
        validationErrors.hour = "Please enter hour/minute.";
      } else {
        if (isNaN(hour) || hour < 0 || hour > 24) {
          validationErrors.hour = "Hour must be between 00 and 24.";
        }
        if (isNaN(minute) || minute < 0 || minute > 59) {
          validationErrors.minute = "Minute must be between 00 and 59.";
        }
      }
    }
  
    scrollToFirstError(validationErrors);
    return validationErrors;
  }
}
export function scheduleEditFormValidation(formData){
  if(formData){
    const validationErrors = {};
    
    if(!formData.schedule_date){
      validationErrors.schedule_date = "Schedule date is required";
    } 
    if(!formData.location_type){
      validationErrors.location_type = "Location type is required";
    } 
    if(!formData.pick_up_time){
      validationErrors.pick_up_time = "Pick up time is required.";
    } 
    if(!formData.drop_off_time){
      validationErrors.drop_off_time = "Drop off time is required.";
    } 
    
    if(!formData.assigned_driver){
      validationErrors.assigned_driver = "Please select Driver.";
    }
    if(!formData.drop_off_loc){
      validationErrors.drop_off_loc = "Please select drop off location.";
    }
    if(!formData.pick_up_loc){
      validationErrors.pick_up_loc = "Please select pick up location.";
    }
    if(!formData.no_of_leg){
      validationErrors.no_of_leg = "Please select leg.";
    }
    if(!formData.is_wheelchair){
      validationErrors.is_wheelchair = "Please select wheel chair.";
    }
    if(!formData.is_wait){
      validationErrors.is_wait = "Please select wait time.";
    }else if(formData.is_wait === '2'){
      if((formData.hour === '' || formData.hour === 0) && (formData.minute === '' || formData.minute === null)){
        validationErrors.hour = "Please enter hour/minute.";
        //validationErrors.minute = "Please enter minute.";
    }
  }
    
    scrollToFirstError(validationErrors);
    return validationErrors;
  }
}
export function addLocationFormValidation(formData){
  //console.log("fff=",formData);
  if(formData){
    const validationErrors = {};

    // if(!formData.loc_address){
    //   validationErrors.loc_address = "Address is required";
    // } 
    if(!formData.location_type){
      validationErrors.location_type = "Location type is required";
    } 
    if(!formData.loc_city){
      validationErrors.loc_city = "City is required";
    } 
    if(!formData.loc_name){
      validationErrors.loc_name = "Location name is required.";
    } 
    if(!formData.loc_state){
      validationErrors.loc_state = "State is required.";
    }
    if(!formData.loc_zip){
      validationErrors.loc_zip = "Zip is required.";
    }
    
    return validationErrors;
  }
}
export function validateAccordion(accordion,scheduleDate,dateMode, startDate, endDate, options = {}) {
  const validationErrors = {};
  const now = moment();
  const skipRideIdForMA = options.isMAPayer === true; // MA: ride_id is auto-generated, not required from user
  const skipRideIdValidation = options.skipRideIdValidation === true;
  const allLocations = Array.isArray(options.allLocations) ? options.allLocations : [];

  if (options.validateScheduledMilesPerLeg) {
    const sm = accordion.scheduled_miles != null ? String(accordion.scheduled_miles).trim() : '';
    if (!sm) {
      validationErrors.scheduled_miles = "Scheduled miles is required.";
    } else {
      const num = Number(sm);
      if (!Number.isFinite(num) || num <= 0) {
        validationErrors.scheduled_miles = "Scheduled miles must be a valid number greater than zero.";
      }
    }
  }

if (!skipRideIdForMA && !skipRideIdValidation && !accordion.ride_id) {
    validationErrors.ride_id = "Ride ID is required.";
  }
if (!accordion.pick_up_loc) {
    validationErrors.pick_up_loc = "Pick up location is required.";
  }
  if (!accordion.drop_off_loc) {
    validationErrors.drop_off_loc = "Drop off location is required.";
  }
  if (accordion.pick_up_loc) {
    const pickUpLocation = allLocations.find((loc) => String(loc?.loc_id) === String(accordion.pick_up_loc));
    const pickUpLocTypeName = pickUpLocation?.locationType?.location_type_name;
    const isPickUpLocTypeMissing =
      pickUpLocation &&
      (
        pickUpLocation.loc_type === null ||
        pickUpLocation.loc_type === undefined ||
        String(pickUpLocation.loc_type).trim() === '' ||
        pickUpLocTypeName === null ||
        pickUpLocTypeName === undefined ||
        String(pickUpLocTypeName).trim() === ''
      );
    if (isPickUpLocTypeMissing) {
      validationErrors.pick_up_loc = "Pick Up Location type is required.";
    }
  }
  if (accordion.drop_off_loc) {
    const dropOffLocation = allLocations.find((loc) => String(loc?.loc_id) === String(accordion.drop_off_loc));
    const dropOffLocTypeName = dropOffLocation?.locationType?.location_type_name;
    const isDropOffLocTypeMissing =
      dropOffLocation &&
      (
        dropOffLocation.loc_type === null ||
        dropOffLocation.loc_type === undefined ||
        String(dropOffLocation.loc_type).trim() === '' ||
        dropOffLocTypeName === null ||
        dropOffLocTypeName === undefined ||
        String(dropOffLocTypeName).trim() === ''
      );
    if (isDropOffLocTypeMissing) {
      validationErrors.drop_off_loc = "Drop off Location type is required.";
    }
  }
if (!accordion.pick_up_time) {
    validationErrors.pick_up_time = "Pick up time is required.";
  }
if (!accordion.drop_off_time) {
    validationErrors.drop_off_time = "Drop off time is required.";
  }
  if (accordion.pick_up_time && accordion.drop_off_time) {
    const pickUpTime = moment(accordion.pick_up_time, 'h:mm A');
    const dropOffTime = moment(accordion.drop_off_time, 'h:mm A');

    if (dropOffTime.isSameOrBefore(pickUpTime)) {
      validationErrors.drop_off_time = "Drop off time must be greater than pick up time.";
    }
  }
    const today = moment().startOf('day');
if(dateMode === 'single') {
  

  const scheduleDay = moment(scheduleDate, 'MM/DD/YYYY').startOf('day');
  const formattedDate = scheduleDay.format('YYYY-MM-DD');
  // Example validation rules
//  if (scheduleDate && accordion.pick_up_time != 'Will Call') {
//     const pickUpDateTime = moment(`${formattedDate} ${accordion.pick_up_time}`, 'YYYY-MM-DD h:mm A');
//     if (scheduleDay.isSame(today, 'day') && pickUpDateTime.isBefore(now)) {
//       validationErrors.pick_up_time = "Pick up time cannot be in the past.";
//     }
//   }
  
//  if (scheduleDate && accordion.drop_off_time != 'Will Call') {
//     const dropOffDateTime = moment(`${formattedDate} ${accordion.drop_off_time}`, 'YYYY-MM-DD h:mm A');
//     if (scheduleDay.isSame(today, 'day') && dropOffDateTime.isBefore(now)) {
//       validationErrors.drop_off_time = "Drop off time cannot be in the past.";
//     }

//   }
  
}else{
  const start = moment(startDate, 'MM/DD/YYYY');
  const end = moment(endDate, 'MM/DD/YYYY');
  for (let day = start.clone(); day.isSameOrBefore(end); day.add(1, 'day')) {
     const formattedDate = day.format('YYYY-MM-DD');

  //    if (accordion.pick_up_time && accordion.pick_up_time != 'Will Call') {
  //   const pickUpDateTime = moment(`${formattedDate} ${accordion.pick_up_time}`, 'YYYY-MM-DD h:mm A');
  //   if (day.isSame(today, 'day') && pickUpDateTime.isBefore(now)) {
  //     validationErrors.pick_up_time = "Pick up time cannot be in the past.";
  //   }
  // }
  // if (accordion.drop_off_time && accordion.drop_off_time != 'Will Call') {
  //     const dropOffDateTime = moment(`${formattedDate} ${accordion.drop_off_time}`, 'YYYY-MM-DD h:mm A');
  //     if (day.isSame(today, 'day') && dropOffDateTime.isBefore(now)) {
  //       validationErrors.drop_off_time = "Drop off time cannot be in the past.";
  //     }

  //   }

  }
}
  return validationErrors;
};
export function validateEditAccordion(accordion){
  const validationErrors = {};
  const now = moment(); 
  // Example validation rules
  if (!accordion.pick_up_time) {
    validationErrors.pick_up_time = "Pick up time is required.";
  }
  if (!accordion.pick_up_loc) {
    validationErrors.pick_up_loc = "Pick up location is required.";
  }
  if (!accordion.drop_off_time) {
    validationErrors.drop_off_time = "Drop off time is required.";
  }
  if (!accordion.drop_off_loc) {
    validationErrors.drop_off_loc = "Drop off location is required.";
  }
  if (accordion.pick_up_time && accordion.drop_off_time) {
    const pickUpTime = moment(accordion.pick_up_time, 'h:mm A');
    const dropOffTime = moment(accordion.drop_off_time, 'h:mm A');

    if (dropOffTime.isSameOrBefore(pickUpTime)) {
      validationErrors.drop_off_time = "Drop off time must be greater than pick up time.";
    }
  }
  
  return validationErrors;
};
export function validateLegs(accordions) {
  const validationErrors = {};

  for (let i = 0; i < accordions.length - 1; i++) {
    const currentLeg = accordions[i];
    const nextLeg = accordions[i + 1];

    if (currentLeg.drop_off_time && nextLeg.pick_up_time) {
      const currentDropOffTime = moment(currentLeg.drop_off_time, 'h:mm A');
      const nextPickUpTime = moment(nextLeg.pick_up_time, 'h:mm A');

      if (currentDropOffTime.isSameOrAfter(nextPickUpTime)) {
        validationErrors[`drop_off_time_${i + 1}`] = `Leg ${i + 1} drop off time must be less than Leg ${i + 2} pick up time.`;
      }
    }
  }

  return validationErrors;
}
// Agency Tax Id: min 3, max 10 alphanumeric (e.g. 3538, AB3538, 3538QIO512)
const AGENCY_TAX_ID_REGEX = /^[A-Za-z0-9]{3,10}$/;
// NPI/UMPI: exactly 10 alphanumeric (e.g. A896566588)
const NPI_UMPI_REGEX = /^[A-Za-z0-9]{10}$/;
// Taxonomy: min 4, max 10 alphanumeric (e.g. A6879989X)
const TAXONOMY_REGEX = /^[A-Za-z0-9]{4,10}$/;
// Contact Name & Receiver Name: letters and spaces only (e.g. Alex, Alex John)
const ALPHABET_ONLY_REGEX = /^[A-Za-z\s]+$/;

export function billConfigurationValidation(formData) {
  // console.log(formData);
   if(formData){
     const validationErrors = {};
     const agencyTaxId = (formData.agency_tax_id || '').trim();
     const npiUmpi = (formData.npi_umpi || '').trim();
     const texonamy = (formData.texonamy || '').trim();
     const contactName = (formData.contact_person_name || '').trim();
     const contactPhone = (formData.contact_person_phone || '').replace(/\D/g, '');

     // 1. Agency Tax Id - mandatory, min 3 max 10 alphanumeric
     if(!agencyTaxId){
       validationErrors.agency_tax_id = "Agency Tax Id is required";
     } else if(!AGENCY_TAX_ID_REGEX.test(agencyTaxId)){
       validationErrors.agency_tax_id = "Agency Tax Id must be 3–10 alphanumeric characters (e.g. 3538, AB3538)";
     }

     // 2. NPI/UMPI - mandatory, exactly 10 alphanumeric
     if(!npiUmpi){
       validationErrors.npi_umpi = "NPI/UMPI is required";
     } else if(!NPI_UMPI_REGEX.test(npiUmpi)){
       validationErrors.npi_umpi = "NPI/UMPI must be exactly 10 alphanumeric characters (e.g. A896566588)";
     }

     // 3. Taxonomy - mandatory, min 4 max 10 alphanumeric
     if(!texonamy){
       validationErrors.texonamy = "Taxonomy is required";
     } else if(!TAXONOMY_REGEX.test(texonamy)){
       validationErrors.texonamy = "Taxonomy must be 4–10 alphanumeric characters (e.g. A6879989X)";
     }

     // 4. Contact Name - mandatory, letters only (no numbers/special chars)
     if(!contactName){
       validationErrors.contact_person_name = "Contact Name is required";
     } else if(!ALPHABET_ONLY_REGEX.test(contactName)){
       validationErrors.contact_person_name = "Contact Name allows only letters. No numbers or special characters.";
     }

     // 5. Contact Phone - mandatory, min 10 digits
     if(!formData.contact_person_phone || !(formData.contact_person_phone + '').trim()){
       validationErrors.contact_person_phone = "Contact Phone is required";
     } else if(contactPhone.length < 10){
       validationErrors.contact_person_phone = "Contact Phone must be at least 10 digits";
     }

     // 6. Receiver Name - mandatory, letters only (no numbers/special chars)
     const receiverName = (formData.receiver_name || formData.dhsData?.receiver_name || '').trim();
     if(!receiverName){
       validationErrors.receiver_name = "Receiver Name is required";
     } else if(!ALPHABET_ONLY_REGEX.test(receiverName)){
       validationErrors.receiver_name = "Receiver Name allows only letters. No numbers or special characters.";
     }

     // 7. Receiver Id - mandatory, min 1 character
     const receiverId = (formData.receiver_id ?? formData.dhsData?.receiver_id ?? '').toString().trim();
     if(!receiverId){
       validationErrors.receiver_id = "Receiver Id is required";
     }

   scrollToFirstError(validationErrors);
     return validationErrors;
   }
} 
export function billRateValidation(formData) {
  if(formData){
    const validationErrors = {};
    if(!formData.service_id){
      validationErrors.service_id = "Service name is required.";
    }
    // if(!formData.procedure_code){
    //   validationErrors.procedure_code = "Procedure code is required.";
    // }
    if(!formData.state){
      validationErrors.state = "State is required.";
    }
    if(!formData.payer_id){
      validationErrors.payer_id = "Payer name is required.";
    }
    if(!formData.base_bill_rate){
      validationErrors.base_bill_rate = "Base bill rate is required.";
    }
    if(!formData.mileage_bill_rate){
      validationErrors.mileage_bill_rate = "Mileage bill rate is required.";
    }
    if(!formData.effective_date){
      validationErrors.effective_date = "Effective date is required.";
    }
    if(!formData.end_date){
      validationErrors.end_date = "End date is required.";
    }
    // Notes is optional - no validation required
    scrollToFirstError(validationErrors);
    return validationErrors;
  }
  
  }



const scrollToFirstError = (validationErrors) => {
  if (Object.keys(validationErrors).length > 0) {
    const firstErrorKey = Object.keys(validationErrors)[0];
    const firstErrorElement = document.querySelector(`[name="${firstErrorKey}"]`);

    if (firstErrorElement) {
      const offset = firstErrorElement.offsetTop;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  }
};

  